import { useEffect } from "react";
import AppToast from ".";
import { displayToast, useToast } from "../../Hook/toast";
import useIsMobile from "../../Hook/mobile";

/**
 * Where the one toast lives (turn 1 contract): fixed above the tab bar on
 * mobile, inset 12px and never over it; top-right under the header on desktop,
 * clear of the chat docks at the bottom. Below sheets, above the feed.
 */
function ToastHolder() {
  const toast = useToast();
  const detectMobile = useIsMobile();

  useEffect(() => {
    (window as any).showToast = (user: any, title: string, message: string, type: any) =>
      displayToast(user, title, message, type);
  }, []);

  if (!toast) return null;

  return (
    <div
      className={
        "fixed z-40 " +
        (detectMobile.isMobile
          ? "left-3 right-3 bottom-nav-safe"
          : "top-20 right-6 w-96")
      }
    >
      <AppToast key={toast.id} toast={toast} />
    </div>
  );
}

export default ToastHolder;
